<template>
  <li>
    <ul class="multi-version-list">
      <version-item v-for="(item, i) in value" :key="i" :value="item"/>
    </ul>
  </li>
</template>

<script>
  import VersionItem from './VersionItem';

  export default {
    components: { VersionItem },
    props: {
      value: Array
    }
  };
</script>

<style lang="less">
  // Specificity required
  .versions-list-outer ul ul.multi-version-list {
    li {
      margin-left: 0;
    }
  }
</style>
